<mat-card>
    <mat-card-header>
      <mat-card-title>Highlighted Projects</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-nav-list>
        <a mat-list-item target="_blank" href="https://openreadersbibles.github.io/pub-farsi/default/index.html">
          <mat-icon matListItemIcon>explore</mat-icon>
          <span matListItemTitle>Jonah, Mark, John, and Johannine epistles with Farsi glosses</span>
        </a>
        <a mat-list-item target="_blank" href="https://openreadersbibles.github.io/pub-bhsa/default/index.html">
          <mat-icon matListItemIcon>explore</mat-icon>
          <span matListItemTitle>Complete Old Testament with English glosses</span>
        </a>
        <a mat-list-item target="_blank" href="https://openreadersbibles.github.io/pub-sblgnt-biblebento/default/index.html">
          <mat-icon matListItemIcon>explore</mat-icon>
          <span matListItemTitle>Complete New Testament with English glosses</span>
        </a>
      </mat-nav-list>
    </mat-card-content>
  </mat-card> 